import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * PortfolioPropertyList Widget
 */
@Component({
  selector: 'portfolio-property-list-widget',
  templateUrl: './portfolio-property-list-widget.component.html',
  styleUrls: ['./portfolio-property-list-widget.component.scss']
})
export class PortfolioPropertyListWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'portfolioPropertyList', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadEmpty();

    this.widgetData$ = this.mockup ?
      this.widgetService.loadMockupData('assets/data/polluxMocks.portfolio-property-list-widget.json').pipe()
      : this.widgetService.load('portfolioPropertyList', this.getReport()).pipe();
  }

  /**
   * Check if columns are filled
  * @param widgetData {any} Widget data
  * @param columnName {string} Column name
   */
  public columnIsFilled(widgetData: any, columnName: string): boolean {
    if (widgetData?.entries) {
      for (const entry of widgetData.entries) {
        if (entry[columnName]) {
          return true;
        }
      }
    }
    return false;
  }
}
